// components/ErrorBoundary.tsx
import React, { type ReactNode } from "react";
import { makeObservable, observable } from "mobx";
import { observer } from "mobx-react";

interface ErrorBoundaryProps {
  fallback: (error: Error) => ReactNode;
  children: ReactNode;
}

@observer
class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  @observable
  error: Error | null = null;

  constructor(props: ErrorBoundaryProps) {
    super(props);
    makeObservable(this);
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info);
    this.error = error;
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    // Reset error when children change
    if (prevProps.children !== this.props.children) {
      this.error = null;
    }
  }

  render() {
    if (this.error) {
      return this.props.fallback(this.error);
    }

    return this.props.children;
  }
}

export default ErrorBoundary;